import { chatRootStore } from './chat-root-store';

export const useChatStore = () => chatRootStore.getStore();
